import { isNumberLike } from "@/utils/common";
import { fmoney } from "@/utils/count";
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("currency", ["currencyMap"]),
  },
  methods: {
    // 传入货币code，获取货币符号，hasBracket返回值是否带括号
    currencyToSymbol(currency, hasBracket = false) {
      const symbol = this.currencyMap[currency] || currency || "";
      if (symbol && hasBracket) {
        return `(${symbol})`;
      } else {
        return symbol;
      }
    },
    // 价格千分位化，传入货币code
    priceCurrencyFormat(price, currency) {
      if (!isNumberLike(price)) return "";
      // 货币符号+千分位金额
      const symbol = this.currencyMap[currency] || currency || "";
      const amount = fmoney(price, 2);
      return `${symbol}${amount}`;
    },
    // 价格千分位化，传入货币符号
    priceSymbolFormat(price, symbol) {
      if (!isNumberLike(price)) return "";
      // 千分位金额
      const amount = fmoney(price, 2);
      return `${symbol}${amount}`;
    },
    // 传入字符串模板，在字符串模板标记处插入相应的值，最后返回对应的语言文本
    languageFormat(template, data) {
      if (!template) return "";
      if (data && Object.keys(data).length > 0) {
        return template.replace(/\{(\w+)\}/g, (match, key) => {
          // 如果 data 对象里有这个 key，就替换它；没有则保留原样(match)或返回空("")
          return data[key] !== undefined ? data[key] : "";
        });
      } else {
        return template;
      }
    },
  },
};
